import { render, staticRenderFns } from "./PlayerInstructions.vue?vue&type=template&id=056e4888&"
import script from "./PlayerInstructions.vue?vue&type=script&lang=js&"
export * from "./PlayerInstructions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports